{
    "name": "@deepstream/client",
    "version": "5.2.7",
    "description": "the javascript client for deepstream.io",
    "keywords": [
        "deepstream",
        "javascript",
        "realtime",
        "client"
    ],
    "mocha": {
        "recursive": true,
        "reporter": "dot",
        "require": "ts-node/register/transpile-only",
        "exit": true
    },
    "main": "dist/src/deepstream.js",
    "types": "dist/src/deepstream-client.d.ts",
    "directories": {
        "test": "src/test"
    },
    "scripts": {
        "tsc": "rm -rf dist && tsc",
        "build": "npm run tsc && npm run build:dev && npm run build:prod",
        "build:dev": "webpack --config webpack.dev.js",
        "build:prod": "webpack --config webpack.prod.js",
        "rebuild": "rimraf dist && webpack",
        "clean": "rimraf dist",
        "lint": "tslint src/*.ts src/**/*.ts -t verbose",
        "lint:fix": "npm run lint -- --fix",
        "test": "mocha src/**/*.spec.ts",
        "test:coverage": "nyc npm test",
        "bundle:analyse": "webpack --config webpack.prod.js --profile --json > ./dist/stats.json && webpack-bundle-analyzer ./dist/stats.json",
        "postinstall": "node scripts/postinstall.js"
    },
    "repository": {
        "type": "git",
        "url": "https://github.com/deepstreamIO/deepstream.io-client-js.git"
    },
    "dependencies": {
        "@deepstream/protobuf": "^1.0.4",
        "protobufjs": "^6.10.2",
        "ws": "^7.4.0"
    },
    "browser": {
        "net": false,
        "ws": false
    },
    "devDependencies": {
        "@istanbuljs/nyc-config-typescript": "^1.0.1",
        "@types/chai": "^4.2.14",
        "@types/mocha": "^8.0.4",
        "@types/node": "^14.14.9",
        "@types/sinon": "^9.0.9",
        "@types/ws": "^7.4.0",
        "chai": "^4.2.0",
        "coveralls": "^3.1.0",
        "husky": "^4.3.0",
        "mocha": "^8.2.1",
        "mocha-lcov-reporter": "^1.3.0",
        "nyc": "^15.1.0",
        "rimraf": "^3.0.2",
        "sinon": "^9.2.1",
        "terser-webpack-plugin": "^4.2.3",
        "ts-essentials": "^7.0.1",
        "ts-loader": "^8.0.11",
        "ts-node": "^9.1.1",
        "tslint": "^6.1.3",
        "typescript": "^4.1.2",
        "uglifyjs-webpack-plugin": "^2.2.0",
        "webpack": "^4.44.2",
        "webpack-bundle-analyzer": "^3.9.0",
        "webpack-cli": "^3.3.12"
    },
    "author": "deepstreamHub GmbH",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/deepstreamIO/deepstream.io-client-js/issues"
    },
    "homepage": "http://deepstream.io",
    "eslintConfig": {
        "extends": "deepstream"
    },
    "husky": {
        "hooks": {
            "pre-commit": "npm t && npm run lint && npm run build",
            "pre-publish": "npm t && npm run build"
        }
    },
    "nyc": {
        "extends": "@istanbuljs/nyc-config-typescript",
        "include": [
            "src/**/*.ts"
        ],
        "exclude": [
            "src/**/*.spec.ts"
        ],
        "extension": [
            ".ts"
        ],
        "require": [
            "ts-node/register"
        ],
        "reporter": [
            "lcov"
        ]
    }
}
